import * as React from 'react';
import { TextValidator } from 'react-material-ui-form-validator';
import MenuItem from '@mui/material/MenuItem';
import authService from '../api-authorization/AuthorizeService';
import CircularProgress from '@mui/material/CircularProgress';

interface IDropdownProps {
    id: number;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

class DropdownViewModel {
    id: number = 0;
    value: string = '';
}

export default function CountryDropdown(props: IDropdownProps) {
    const [list, setList] = React.useState<DropdownViewModel[]>([]);
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        setLoaded(false);
        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();

        const response = await fetch('Account/GetCountries', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        setList(data.value);
        setLoaded(true);
    }

    const items = list.map((item, index) =>
        <MenuItem key={index} value={item.id}>{item.value}</MenuItem>);

    return (
        <TextValidator
            select
            label="Country"
            name="ref_CountryId"
            variant="outlined"
            validators={['required']}
            errorMessages={['This field is required']}
            fullWidth
            onChange={props.onChange}
            value={items.length <= 0 || props.id === 0 ? '' : props.id}
            InputProps={{
                disabled: !loaded,
                startAdornment: (
                    <React.Fragment>
                        {loaded ? null : <CircularProgress size={20} />}
                    </React.Fragment>
                )
            }}
        >
            {items}
        </TextValidator>
    );
}